import { BaseService } from '@Services/index'

export class CustomerService extends BaseService {
	
	public getPatientList(cst_id: string): Promise<any> {
		return super.get(`/customer/${cst_id}/patients`)
	}
}